// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Fg0f","label":"Labeled_label__8MkHf","divider":"Labeled_divider__-Fn2t"};